import Error from "./assets/error.svg";
import React from "react";
import LandingTypography from "../../../Homepage/components/LandingTypography";
import { compose } from "redux";
import withTranslations from "../../../../../../../hocs/withTranslations";
import { UrlProvider } from "../../../../../../../api/UrlProvider";
import useIsDesktop from "../../../../hooks/useIsDesktop";
import classNames from "classnames";

const ErrorPage = ({ title, description, translate, locale, refreshUrl }) => {
  const isDesktop = useIsDesktop();

  return (
    <LandingTypography className={"plans"}>
      <div className={"flex flex-col align-center text-center mt-14"}>
        <img
          src={Error}
          alt={translate("Error icon")}
          height={isDesktop ? 300 : 200}
          width={isDesktop ? 403 : 268}
        />
        <h1
          className={classNames(
            "mt-10 mb-4 text-2xl font-semibold text-black text-center",
            {
              "mt-10 text-2xl": isDesktop,
              "mt-6 text-xl": !isDesktop
            }
          )}
        >
          {title ?? translate("error-page_title")}
        </h1>
        <p
          className={classNames("text-black opacity-70 max-w-90", {
            "text-xs": isDesktop,
            "text-sm": !isDesktop
          })}
        >
          {description ?? translate("error-page_description")}
        </p>
        <a
          className={"button-1"}
          href={
            refreshUrl
              ? refreshUrl
              : UrlProvider.getUrl("fe.homeWithLocale", { locale })
          }
        >
          {translate("Refresh page")}
        </a>
      </div>
    </LandingTypography>
  );
};

export default compose(withTranslations)(ErrorPage);
